export const parameterization: any[] = [
    {label: "Somente dispara a notificação", value: "1"},
    {label: "Somente verifica os dados do cliente", value: "6"},
    {label: "Somente verifica os produtos disponíveis", value: "2"},
    {label: "Dispara a notificação SOMENTE se o cliente houver produtos disponíveis", value: "3"},
    {label: "Dispara a notificação INDEPENDENTE se o cliente houver ou não produtos disponíveis", value: "4"},
    {label: "Digitações em Lote", value: "5"},
]